'use strict';

angular.module('ClinicApp').factory('MembershipService', function($http, ClinicConfig) {
  return {
    createDefault: (clinicId, data) =>
      $http
        .post(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/membership`, data)
        .then((response) => response.data),

    listPaymentMethods: (clinicId) =>
      $http
        .get(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/membership/paymentMethods`)
        .then((response) => response.data),

    updatePaymentMethod: (clinicId, membershipId, data) =>
      $http
        .post(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/membership/${membershipId}/paymentMethod`, data)
        .then((response) => response.data),

    checkBillingRun: (clinicId) =>
      $http
        .get(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/membership/bill`)
        .then((response) => response.data),

    runBilling: (clinicId, { year, month }) =>
      $http
        .post(`${ClinicConfig.HOSTNAME}/clinic/${clinicId}/membership/bill`, {
          year,
          month,
        })
        .then((response) => response.data),
  };
});
